import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection1 from "./HeroSection1";
import FeatureSection1 from "./FeatureSection1";
import VisualizationSection1 from "./VisualizationSection1";
import Contact from "../../Components/Contact/Contact";
import Footer from "../../Components/Footer/Footer";
import GraphSection from "./GraphSection";

const App1Page = () => {
  useEffect(() => {
    // Add 'biolingo-page' class to <body> for page-specific styles
    document.body.classList.add("biolingo-page");

    // Update the page title
    const previousTitle = document.title;
    document.title = "Biolingo - AI-Powered Plant Wellness Tracker | Galaxy Advisors";

    // Scroll to the top of the page when this component loads
    window.scrollTo(0, 0);

    // Cleanup on component unmount
    return () => {
      document.body.classList.remove("biolingo-page");
      document.title = previousTitle; // Restore the previous title
    };
  }, []);

  return (
    <div>
      {/* SEO Metadata for Social Sharing and Search Engines */}
      <Helmet>
        <title>Biolingo - AI-Powered Plant Wellness Tracker | Galaxy Advisors</title>
        <meta name="description" content="Discover Biolingo, an AI-powered plant wellness tracking tool by Galaxy Advisors." />
        <meta property="og:title" content="Biolingo - AI-Powered Plant Wellness Tracker" />
        <meta property="og:description" content="AI-driven bio-sensors for plant well-being tracking." />
        <meta property="og:image" content="https://galaxyadvisors.com/biolingoPagePreview.png" />
        <meta property="og:url" content="https://galaxyadvisors.com/biolingo" />
      </Helmet>

      {/* Modularized Sections */}
      <HeroSection1 />
      <VisualizationSection1 />
      <FeatureSection1 />
      <GraphSection />
      <Contact />
      <Footer />
    </div>
  );
};

export default App1Page;
